import React from "react";

import { Icon } from "react-icons-kit";
import { move } from "react-icons-kit/feather/";

import {
    colors
  } from "../../../../../helpers/constants";

const HoverOverlay = props => {
  // let {
  //   onStartMoveWidget,
  //   onDeleteWidget,
  //   onResizeWidget,
  //   onToggleWidgetSettings
  // } = props;
  return (
    <div className="widget-overlay">
      <div className="widget-overlay-inner">

        <div style={{color: colors["selected"]}}>
      <Icon size={24} icon={move} /></div>

      </div>

    </div>
  );
};

export default HoverOverlay;
